import React, { useContext } from 'react'
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from "react-bootstrap/AccordionContext";
import Card from 'react-bootstrap/Card'
import { RiArrowDropDownLine } from "react-icons/ri";
import './AccordionToggle.scss'

function ContextAwareToggle({ children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
      eventKey,
      () => callback && callback(eventKey),
    );
  
    const isCurrentEventKey = currentEventKey === eventKey;
  
    return (
      <Card.Text
      onClick={decoratedOnClick}
      className={isCurrentEventKey ? "card-text-open" : "card-text-closed"}
      >
        <RiArrowDropDownLine size={22.5} className={isCurrentEventKey ? "arrow-accordion-open" : "arrow-accordion-closed"} />   
        {children}
      </Card.Text>
    );
  }

export default ContextAwareToggle
